/*
 * Calculate visible view width.
 */

const maxWidth = null; // Remember to also change value in variables.scss
const horisontalPadding = 4 * 16; // Total horisontal padding on desktop * 16px

const setupBodyViewWidth = () => {
    let vw = window.innerWidth;
    if(maxWidth != null && vw >= (maxWidth + horisontalPadding)) {
        vw = maxWidth + horisontalPadding;
    }
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
setupBodyViewWidth();
window.addEventListener('resize', setupBodyViewWidth);
